import React from 'react'
import styled from 'styled-components'
import Surface from '../../../../../../generic/ui/Surface'

type Props = {
  title: string
  children: React.ReactNode
}

/** knisot-style page wrapper: full-height surface card with a title and a scrollable body. */
const PalletActionLayout = ({ title, children }: Props) => (
  <Page>
    <Card>
      <Header>{title}</Header>
      <Body>{children}</Body>
    </Card>
  </Page>
)

export default PalletActionLayout

const Page = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.bgLayout};
  display: flex;
  justify-content: center;
  padding: 1.5rem 1rem;
  direction: rtl;
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 1rem 0.75rem;
  }
`

const Card = styled(Surface)`
  width: 100%;
  max-width: 32rem;
  height: 100%;
`

const Header = styled.h2`
  flex-shrink: 0;
  margin: 0;
  padding: 1.25rem 1.5rem;
  font-family: ${({ theme }) => theme.fonts.sans};
  font-size: ${({ theme }) => theme.text.lg};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.ink};
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  text-align: start;
`

const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 1.5rem;

  /* Hidden scrollbar (width 0) */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 1rem;
  }
`
